import React from 'react';
import moment from 'moment-timezone';
import Translate from '@spordle/intl-elements';

import Table from '../Table';
import { TableHeader, TableRow } from './GameListTableBody';
import Loader from '../Loader';
import { useLocale } from '../../i18n';

export default ({ currentRows, schedules, loading, filters, hideDate, hideScheduleName, totalRows, ...props }) => {
  const [ locale ] = useLocale();
  return <Table
    size={null}
    className="gamelist-table"
    currentRows={currentRows}
    renderMessage={() => {
      if (loading === 'loading') return <Loader><Translate id="components.gamelist.loading" /></Loader>
      if (loading === 'error') return <p><Translate id="components.gamelist.load.fail" /></p>

      if (currentRows?.length > 0) return;

      if (filters && filters.startDate && !filters.startDate.gte) {
        const startDate = moment(filters.startDate);
        if (moment().isSame(startDate, 'day')) return <p><Translate id="components.gamelist.no.games.today" /></p>;

        const i18nKey = startDate.isAfter(undefined, 'day') ?
          'components.gamelist.no.games.that.day' :
          'components.gamelist.no.games.that.day.past';
        const day = startDate.locale(locale).format('LL');
        return <p><Translate id={i18nKey} values={{ day }} /></p>
      }

      return <p><Translate id="components.gamelist.no.upcoming.games" /></p>
    }}
    renderHeader={({ isMobile }) =>
      <TableHeader
        isMobile={isMobile}
        hideDate={hideDate}
      />
    }
    renderRow={({ isMobile, row: game, index }) => {
      const schedule = schedules?.find(schedule => schedule.id === game.scheduleId)
      return <TableRow
        game={game}
        schedule={schedule}
        isMobile={isMobile}
        hideDate={hideDate}
        hideScheduleName={hideScheduleName}
        index={index}
        key={game.id}
      />
    }}
    {...props}
  />
}
